import url from './url';



export default url(({ testId = ':testId', testName = ':testName' }) => `/mixins-experiments/${testId}/${testName}`);
